import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface NavigationStore {
  navigationStack: string[];
  pushRoute: (route: string) => void;
  popRoute: () => string | null;
  clearStack: () => void;
  getBackRoute: () => string | null;
}

export const useNavigationStore = create<NavigationStore>()(
  persist(
    (set, get) => ({
      navigationStack: [],

      pushRoute: (route: string) => {
        set((state) => {
          // Don't push the same route consecutively
          const stack = [...state.navigationStack];
          if (stack[stack.length - 1] !== route) {
            stack.push(route);
            // Keep only last 10 routes to prevent memory bloat
            if (stack.length > 10) stack.shift();
          }
          return { navigationStack: stack };
        });
      },

      popRoute: () => {
        const state = get();
        if (state.navigationStack.length === 0) return null;
        
        const stack = [...state.navigationStack];
        const route = stack.pop();
        set({ navigationStack: stack });
        return route || null;
      },

      getBackRoute: () => {
        const state = get();
        // Return the previous route without popping
        return state.navigationStack.length > 0 
          ? state.navigationStack[state.navigationStack.length - 1] 
          : null;
      },

      clearStack: () => set({ navigationStack: [] }),
    }),
    {
      name: 'navigation-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
